angular.module('shared-calendar')
    .controller('SharedCalendarBatchAddModalController', function (SharedCalendar, $uibModalInstance) {
        this.$onInit = () => {
            this.form = {
                owners: [],
                users: []
            };
        };

        this.save = () => SharedCalendar.share(this.form).$promise.then(result => $uibModalInstance.close(result));

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
